import { EFavoritesType, ISelectItem } from 'lib/types';
import { useState } from 'react';
import styles from './styles.module.scss';
import { Virtuoso } from 'react-virtuoso';
import useVirtualListStyle from 'hooks/use-virtial-list-style';
import LoadMoreVirtualListFooter from 'components/load-more-virtual-list-footer';
import FavoriteListItemUser from 'components/favorite-list-item-user';
import BaseScreen from 'components/base-screen';
import { useLocation } from 'react-router-dom';
import { FavouritesType, UsersType } from 'lib/dictionary';
import { Select } from 'components/select';
import Button from 'components/button';
import useChangeFavoriteList from 'api/hooks/use-favorite-list-change';
import BottomSheetConfirm from 'components/bottom-sheet-confirm';
import useFavoriteListItem from 'api/hooks/use-favorite-list-item';
import useUserList, { APIUser } from 'api/hooks/use-users-list';
import { getName } from 'lib/utils';
import { APIUserType } from 'api/types';

const UserListFavoriteListItem = () => {
  const { users, isLoading } = useUserList();

  const [clientIds, setClientIds] = useState<number[]>([]);
  const [clientIdDelete, setClientIdDelete] = useState<number>(0);
  const { id, title, type } = useLocation()?.state;
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  const { listItem, error, isLoading: isLoadingUsersList, mutate } = useFavoriteListItem(id);
  const userList = listItem.clients;

  const { trigger, isMutating } = useChangeFavoriteList(id);

  const handleAddUser = async () => {
    if (id && clientIds.length) {
      await trigger({ clientIds: [...clientIds, ...userList.map((user) => user.id)] });
      setClientIds([]);
      mutate();
    }
  };

  const handleDeleteUser = async () => {
    if (clientIdDelete) {
      const clientIds = userList
        .filter((user) => user.id !== clientIdDelete)
        .map((user) => user.id);
      await trigger({ clientIds: clientIds });
      setClientIdDelete(0);
      setIsBottomSheetOpen(false);
      mutate();
    }
  };

  const handleChange = (value: number[]) => {
    setClientIds(value);
  };

  const isShared = type === EFavoritesType.Shared;
  const isCustomer = type === EFavoritesType.Customer;

  const menuArrayOptions: ISelectItem[] = (function () {
    let userListFileterd: APIUser[] = [];

    if (isShared) {
      userListFileterd = users?.filter((user) => user.type !== APIUserType.CLIENT);
    }

    if (isCustomer) {
      userListFileterd = users?.filter((user) => user.type === APIUserType.CLIENT);
    }

    return userListFileterd
      .filter((user1) => {
        if (userList?.find((user2) => user1.id === user2.id)) {
          return false;
        }
        return true;
      })
      .map((users) => ({
        key: users.id,
        label: getName(users.fullname),
        note: users.phone + ' ' + UsersType.label(users.type),
      }));
  })();

  const listStyle = useVirtualListStyle();

  return (
    <BaseScreen padContent floatingButtons={false} title='Пользователи списка'>
      <div>
        {type && (
          <div className={styles.title}>{`${FavouritesType.label(type)} список "${title}"`}</div>
        )}

        <div className={styles.menu}>
          <div style={{ width: '70%' }}>
            <Select
              search
              onSelect={handleChange}
              selected={clientIds}
              menuArray={menuArrayOptions}
              label='Пользователи'
              size='md'
              multiple={true}
            />
          </div>
          <div className={styles.menuButton}>
            <Button className={styles.btn} label='Добавить' onClick={handleAddUser} />
          </div>
        </div>

        {userList?.length > 0 ? (
          <Virtuoso
            useWindowScroll
            data={userList}
            style={listStyle}
            itemContent={(index, user) => {
              return (
                <FavoriteListItemUser
                  indexOnList={index + 1}
                  user={user}
                  onDelete={(id) => {
                    setClientIdDelete(id);
                    setIsBottomSheetOpen(true);
                  }}
                />
              );
            }}
            components={{ Footer: LoadMoreVirtualListFooter }}
          />
        ) : (
          <div className={styles.titleNotFound}>нет пользователей</div>
        )}

        <BottomSheetConfirm
          isOpen={isBottomSheetOpen}
          onAgree={() => handleDeleteUser()}
          title={'Вы уверены что хотите удалить данного пользователя?'}
          onDismiss={() => setIsBottomSheetOpen(false)}
          isLoading={isMutating}
        />
      </div>
    </BaseScreen>
  );
};

export default UserListFavoriteListItem;
